export default class Config {
    constructor() {
        this._api_url = "https://api.saude.pa.gov.br/sgp-api/";
        //this._api_url = "http://localhost:8080/";
    }

    get api_url() {
        return this._api_url;
    }

    set api_url(value) {
        this._api_url = value;
    }
}
